import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { baseurladdress } from "../baseurl";
import Swal from "sweetalert2";
import $ from "jquery";
import { NavLink } from "react-router-dom";
import { useParams } from "react-router-dom";

function EditClinic() {
    const accesstoken = localStorage.getItem("token");
    const accessuserid = localStorage.getItem("id");
    const [cliName, setCliName] = useState("");
    const [cliCode, setCliCode] = useState("");
    const [cliContact, setCliContact] = useState("");
    const [cliAddress, setCliAddress] = useState("");
    const [cliCountry, setCliCountry] = useState("");
    const [cliState, setCliState] = useState("");
    const [cliDistrict, setCliDistrict] = useState("");
    const [cntry_name, setcntry_name] = useState("");
    const [state_name, setstate_name] = useState("");
    const [district_name, setdistrict_name] = useState("");
    const [cliPin, setCliPin] = useState("");
    const [cliCoord, setCliCoord] = useState("");
    const [cliEmail, setCliEmail] = useState("");
    const [cliWebsite, setCliWebsite] = useState("");
    const [cliServedBy, setCliServedBy] = useState("");
    const [staffList, setStaffList] = useState([]);
    const { clinic_id } = useParams();
    let navigate = useNavigate();

    useEffect(() => {
        const getcountry = () => {
            axios
                .get(baseurladdress + "staff/getallcountry", {
                    headers: { Authorization: `Bearer ${accesstoken}` },
                })
                .then((res) => {
                    if (res.data.status === "Success") {
                        const options = res.data.countries.map((item) => (
                            <option key={item.cntry_id} value={item.cntry_id}>
                                {item.cntry_name}
                            </option>
                        ));

                        setcntry_name(options);
                    } else {
                        setcntry_name([]);
                    }
                })
                .catch((error) => {
                    console.error(error);
                    alert("Failed to load countries");
                });
        };

        getcountry();
    }, []);

    // Fetch staff list
    useEffect(() => {
        const getAllStaff = async () => {
            try {
                const res = await axios.get(baseurladdress + "staff/findallstaff", {
                    headers: { Authorization: `Bearer ${accesstoken}` },
                });
                if (res.data.status === "Success") {
                    setStaffList(res.data.staff || []);
                } else {
                    setStaffList([]);
                }
            } catch (err) {
                console.error(err);
                setStaffList([]);
            }
        };
        getAllStaff();
    }, [accesstoken]);

    const changeTitle = (staffcntry) => {
        axios
            .get(baseurladdress + "staff/getstates/" + staffcntry, {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
            .then((res) => {
                if (res.data.status === "Success") {
                    const options = res.data.states.map((item) => (
                        <option key={item.state_id} value={item.state_id}>
                            {item.state_name}
                        </option>
                    ));

                    setstate_name(options);
                } else {
                    setstate_name([]);
                }
            })
            .catch((error) => {
                console.error(error);
                alert("Failed to load states");
            });
    };

    const changeDistricts = (staffdistrict) => {
        axios
            .get(baseurladdress + "staff/getdistricts/" + staffdistrict, {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
            .then((res) => {
                if (res.data.status === "Success") {
                    const options = res.data.districts.map((item) => (
                        <option key={item.district_id} value={item.district_id}>
                            {item.district_name}
                        </option>
                    ));

                    setdistrict_name(options);
                } else {
                    setdistrict_name([]);
                }
            })
            .catch((error) => {
                console.error(error);
                alert("Failed to load districts");
            });
    };

    useEffect(() => {
        axios
            .get(baseurladdress + `clinic/editclinic/${clinic_id}`, {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
            .then((res) => {
                if (res.data.status === "Success") {
                    // FIXED: Changed from res.data.hospital to res.data.clinic
                    const data = res.data.clinic;

                    setCliName(data.clinic_name);
                    setCliCode(data.clinic_code);
                    setCliContact(data.clinic_contact);
                    setCliCountry(data.clinic_cntry);
                    setCliState(data.clinic_state);
                    setCliDistrict(data.clinic_district);
                    setCliAddress(data.clinic_address);
                    setCliPin(data.clinic_pin);
                    setCliEmail(data.clinic_email);
                    setCliWebsite(data.clinic_website);
                    setCliCoord(data.clinic_coord);
                    setCliServedBy(data.clionic_servdby || "");

                    // Load states and districts for the selected country and state
                    if (data.clinic_cntry) {
                        changeTitle(data.clinic_cntry);
                    }
                    if (data.clinic_state) {
                        changeDistricts(data.clinic_state);
                    }
                } else {
                    console.warn("clinic not found");
                }
            })
            .catch((error) => {
                console.error("Edit clinic fetch error:", error);
            });
    }, [clinic_id]);

    const handleSubmit = (event) => {
        event.preventDefault();

        const data = {
            clinic_id: clinic_id,
            clinic_name: cliName,
            clinic_code: cliCode,
            clinic_contact: cliContact,
            clinic_country: cliCountry,
            clinic_state: cliState,
            clinic_district: cliDistrict,
            clinic_address: cliAddress,
            clinic_pin: cliPin,
            clinic_email: cliEmail,
            clinic_website: cliWebsite,
            clinic_coord: cliCoord,
            clinic_servedby: cliServedBy,
            clinic_updby: accessuserid,
        };

        // FIXED: Changed endpoint to clinic/updateclinic
        fetch(baseurladdress + "clinic/updateclinic", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${accesstoken}`,
            },
            body: JSON.stringify(data),
        })
            .then((res) => res.json())
            .then((result) => {
                const Toast = Swal.mixin({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 800,
                    timerProgressBar: true,
                });

                if (result.status === "Success") {
                    Toast.fire({
                        icon: "success",
                        title: "Clinic Updated Successfully",
                    });
                    navigate("/clinics");
                } else {
                    Toast.fire({
                        icon: "error",
                        title: "Something went wrong",
                    });
                }
            })
            .catch((error) => {
                console.error("Clinic update error:", error);
            });
    };

    return (
        <div className="staff-page">
            <div className="staff-container">
                <div className="staff-header">
                    <NavLink to="/clinics">
                        <div className="float">
                            <i className="fa fa-arrow-left my-float"></i>
                        </div>
                    </NavLink>
                </div>
                <form className="staff-form" onSubmit={handleSubmit}>
                    <div className="staff-columns">

                        {/* LEFT COLUMN */}
                        <div className="staff-column">
                            <div className="staff-card">
                                <div className="staff-card-body">

                                    <div className="card-header">
                                        <h4 className="card-title">EDIT CLINIC</h4>
                                        <div className="staff-heading-divider"></div>
                                    </div>

                                    <div className="staff-fields">

                                        <div className="staff-group">
                                            <label>Clinic Name <span className="staff-required">*</span></label>
                                            <input
                                                type="text"
                                                value={cliName}
                                                onChange={(e) => setCliName(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div className="staff-group">
                                            <label>Clinic Code <span className="staff-required">*</span></label>
                                            <input
                                                type="text"
                                                value={cliCode}
                                                onChange={(e) => setCliCode(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div className="staff-group">
                                            <label>Contact <span className="staff-required">*</span></label>
                                            <input
                                                type="text"
                                                value={cliContact}
                                                onChange={(e) => setCliContact(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div className="staff-group">
                                            <h6><span style={{ "color": "red" }}>*</span>Country </h6>
                                            <select
                                                className="form-control select"
                                                name="Country"
                                                value={cliCountry}
                                                onChange={e => { changeTitle(e.target.value); setCliCountry(e.target.value) }}
                                            >
                                                <option value="">Select</option>
                                                {cntry_name}
                                            </select>
                                        </div>

                                        <div className="staff-group">
                                            <h6><span style={{ "color": "red" }}>*</span>State </h6>
                                            <select
                                                className="form-control select"
                                                name="State"
                                                value={cliState}
                                                onChange={e => { changeDistricts(e.target.value); setCliState(e.target.value) }}
                                            >
                                                <option value="">Select</option>
                                                {state_name}
                                            </select>
                                        </div>

                                        <div className="staff-group">
                                            <h6><span style={{ "color": "red" }}>*</span>District </h6>
                                            <select
                                                className="form-control select"
                                                name="District"
                                                value={cliDistrict}
                                                onChange={(e) => setCliDistrict(e.target.value)}
                                            >
                                                <option value="">Select</option>
                                                {district_name}
                                            </select>
                                        </div>

                                        <div className="staff-group">
                                            <h6>Served By (Staff)</h6>
                                            <select
                                                className="form-control select"
                                                name="clinic_servedby"
                                                value={cliServedBy}
                                                onChange={(e) => setCliServedBy(e.target.value)}
                                            >
                                                <option value="">Select Staff</option>
                                                {staffList.map((staff) => (
                                                    <option key={staff.staff_id} value={staff.staff_id}>
                                                        {staff.staff_name} - {staff.staff_code}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>

                        {/* RIGHT COLUMN */}
                        <div className="staff-column">
                            <div className="staff-card">
                                <div className="staff-card-body">

                                    <div className="staff-fields">

                                        <div className="staff-group">
                                            <label>Address <span className="staff-required">*</span></label>
                                            <textarea
                                                rows="3"
                                                value={cliAddress}
                                                onChange={(e) => setCliAddress(e.target.value)}
                                                required
                                            ></textarea>
                                        </div>

                                        <div className="staff-group">
                                            <label>Pincode <span className="staff-required">*</span></label>
                                            <input
                                                type="text"
                                                value={cliPin}
                                                onChange={(e) => setCliPin(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div className="staff-group">
                                            <label>Email</label>
                                            <input
                                                type="email"
                                                value={cliEmail}
                                                onChange={(e) => setCliEmail(e.target.value)}
                                            />
                                        </div>

                                        <div className="staff-group">
                                            <label>Website</label>
                                            <input
                                                type="url"
                                                value={cliWebsite}
                                                onChange={(e) => setCliWebsite(e.target.value)}
                                            />
                                        </div>

                                        <div className="staff-group">
                                            <label>Coordinates</label>
                                            <input
                                                type="text"
                                                placeholder="Lat, Long"
                                                value={cliCoord}
                                                onChange={(e) => setCliCoord(e.target.value)}
                                            />
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="staff-btn-container">
                        <button type="submit" className="staff-btn">Submit</button>
                    </div>
                </form>
            </div>
        </div>

    )
}
export default EditClinic;